import { Injectable } from '@angular/core';
import { ResultsetErrorElement } from '@models/resultset-error-element';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ResultsetErrorsStoreService {
  private _currentSheetErrors$: BehaviorSubject<ResultsetErrorElement> = new BehaviorSubject<ResultsetErrorElement>({
    id: null,
    references: []
  });

  public get currentSheetErrors$(): BehaviorSubject<ResultsetErrorElement> {
    return this._currentSheetErrors$;
  }
  public set currentSheetErrors$(value: BehaviorSubject<ResultsetErrorElement>) {
    this._currentSheetErrors$ = value;
  }

  constructor() {}
}
